<template>
  <div class="d-flex flex-grow-1 flex-column overflow-hidden height-245 pointer">
    <div class="fs-6 m-0">{{ chat.createUser.firstName + ' ' + chat.createUser.lastName }}</div>
    <div class="me-2 mb-0 fs-7">{{ chat.message }}</div>
  </div>
</template>

<script>
export default {
  props: {
    chat: {
      type: Object,
    }
  },
}
</script>